import { render, staticRenderFns } from "./ContestMain.vue?vue&type=template&id=63ca40ca&scoped=true&"
import script from "./ContestMain.vue?vue&type=script&lang=js&"
export * from "./ContestMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca40ca",
  null
  
)

export default component.exports